export default function Hero() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20minimalist%20collage%20of%20fashion%20product%20silhouettes%20including%20sneakers%20hoodie%20cap%20and%20bag%20floating%20on%20warm%20gradient%20cream%20to%20terracotta%20background%2C%20soft%20ethereal%20lighting%2C%20abstract%20geometric%20shapes%2C%20modern%20editorial%20art%20style%2C%20clean%20dreamy%20composition%20with%20negative%20space%2C%20sophisticated%20contemporary%20aesthetic&width=1800&height=1000&seq=hb-hero-v2-montage&orientation=landscape"
          alt="Hoobuy Spreadsheet - Produtos da China"
          title="Hoobuy Spreadsheet Produtos"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full px-6 md:px-10 text-center">
        <div className="max-w-3xl mx-auto">
          <span className="inline-block px-4 py-1.5 text-xs font-medium text-background-50/90 bg-background-50/10 backdrop-blur-sm rounded-full mb-6 border border-background-50/20">
            Atualizado Diariamente
          </span>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-4">
            Hoobuy Spreadsheet 2026
            <br />
            <span className="text-primary-400">A Lista Mais Completa</span>
          </h1>
          <p className="text-sm md:text-base text-background-50/80 max-w-xl mx-auto mb-8 leading-relaxed">
            Encontre os melhores produtos da China com preços baixos usando o
            Hoobuy Spreadsheet. A lista mais completa e atualizada com ofertas
            reais verificadas diariamente.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-8 py-3 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-full transition-all cursor-pointer whitespace-nowrap w-full sm:w-auto"
            >
              Hoobuy Sheet
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-8 py-3 text-sm font-semibold text-background-50 border border-background-50/40 hover:bg-background-50/10 rounded-full transition-all cursor-pointer whitespace-nowrap w-full sm:w-auto"
            >
              Comprar Agora
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-2xl text-background-50/60"></i>
      </div>
    </section>
  );
}